var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('terms-dialog', _vm._b({
    on: {
      "isLoaded": _vm.setTermsList,
      "input": function (value) {
        return _vm.$emit('input', value);
      },
      "isValid": function (isValid) {
        return _vm.$emit('isValid', isValid);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          isValid = _ref.isValid;
        return [_c('div', _vm._g({
          staticClass: "cursor-pointer"
        }, on), [_c('card-primary', {
          attrs: {
            "cardInnerSize": "card-inner--sm"
          }
        }, [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, _vm._l(_vm.termsList, function (terms) {
          return _c('v-col', {
            key: terms._id,
            attrs: {
              "cols": "auto"
            }
          }, [terms.code == 'collect-use' ? _c('v-checkbox', {
            staticClass: "my-8px my-md-12px",
            attrs: {
              "value": _vm.selected.includes(terms._id),
              "hide-details": "",
              "color": "primary",
              "readonly": ""
            },
            scopedSlots: _vm._u([{
              key: "label",
              fn: function () {
                return [_c('b', {
                  staticClass: "grey--text text--darken-4"
                }, [_vm._v(" " + _vm._s(terms.subject) + " 동의 "), _c('span', {
                  staticClass: "pl-2px",
                  class: [terms.necessary ? 'red--text' : 'grey--text text--lighten-1']
                }, [_vm._v("(" + _vm._s(terms.necessary ? "필수" : "선택") + ")")]), _vm._v(" "), _c('u', {
                  staticClass: "ml-6px ml-md-10px"
                }, [_vm._v("전문보기")])])];
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1);
        }), 1)], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, 'terms-dialog', {
    params: _vm.params
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }